import { Typescratcher as Ts } from "@tscratch3/typescratcher";

// 【音を読み込む】
const Collect = 'https://cdn.assets.scratch.mit.edu/internalapi/asset/32514c51e03db680e9c63857b840ae78.wav/get';
export const CollectSound = new Ts.Sound( {
    Collect 
} );
const Chirp = 'https://cdn.assets.scratch.mit.edu/internalapi/asset/3b8236bbb288019d93ae38362e865972.wav/get';
export const ChirpSound = new Ts.Sound( {
    Chirp 
} );
const CrashBeatbox = 'https://cdn.assets.scratch.mit.edu/internalapi/asset/725e29369e9138a43f11e0e5eb3eb562.wav/get';
export const CrashBeatboxSound = new Ts.Sound( {
    CrashBeatbox 
} );
